<template>
  <div class="block">
    <el-row :gutter="30">
      <el-col :span="12" style="padding: 45px 15px 0px 15px !important;"><video width="100%"  autoplay muted loop controls ref="videoForm">
        <source :src="vdSrc">
      </video>
      </el-col>
      <el-col :span="12">
        <div style="margin-top: 32px;"><img :src="logoSrc" style="width: 15%;height: 15%"></div>
        <h4 >{{ brandtitleSrc }}</h4>
        <p style="text-align: left; line-height:22px;font-size:13px ;padding: 0 15%;text-align: justify;" >{{ contentSrc }}</p>
        <el-button class="jm-btn" @click="jmsubmit">酒店加盟</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "VideoPlugin",
  props: {
    vdSrc: {
      type: String,
      default: ''
    },
    logoSrc: {
      type: String,
      default: ''
    },
    brandtitleSrc: {
      type: String,
      default: ''
    },
    contentSrc: {
      type: String,
      default: ''
    }
  },
  mounted() {
    this.autoPlay()
  },
  data() {
    return {
    }
  },
  methods: {
    autoPlay() {
      this.$refs.videoForm.play()
    },
    jmsubmit() {
      this.$router.push({path: 'contactWe'})
    }
  }
}
</script>

<style scoped>
.block{
  text-align:center;
  width: 75%;
  margin: 120px auto;
}
.jm-btn {
  color: white;
  background-color: rgb(158, 0, 40);
  width: 350px;
  height: 50px;
  margin-top: 30px;
}
.jm-btn:hover {
  color: white;
  background-color: rgb(158, 0, 40);
  opacity: 0.8;
}
</style>
